import React, { useEffect, useState } from 'react';
import { Alert, Snackbar } from '@mui/material';
import { useMerchantAuth } from '../../../contexts/MerchantAuthContext';
import FlutterServicesAPI from '../../../services/flutterServices';

// Free tokens are granted only after an admin approves the merchant's account.
// Shows a one-time toast when a pending account is approved; pending/rejected status is
// shown in the signup popup, profile, tokens page and generate page instead of a banner.
const STATUS_STORAGE_KEY = 'glammify_verification_status';

const readStoredStatus = () => {
  try {
    return localStorage.getItem(STATUS_STORAGE_KEY);
  } catch (e) {
    return null;
  }
};

const storeStatus = (status) => {
  try {
    localStorage.setItem(STATUS_STORAGE_KEY, status);
  } catch (e) {
    // storage unavailable — the toast simply won't show
  }
};

const VerificationStatusBanner = () => {
  const { merchant } = useMerchantAuth();
  const [showApprovedToast, setShowApprovedToast] = useState(false);
  const status = merchant?.verification_status;
  const tokenLabel = FlutterServicesAPI.getCreditLabel().toLowerCase();

  useEffect(() => {
    if (!status) return;
    if (status === 'approved' && readStoredStatus() === 'pending' && merchant?.free_tokens_granted) {
      setShowApprovedToast(true);
    }
    storeStatus(status);
  }, [status, merchant?.free_tokens_granted]);

  return (
    <Snackbar
      open={showApprovedToast}
      autoHideDuration={6000}
      onClose={() => setShowApprovedToast(false)}
      anchorOrigin={{ vertical: 'top', horizontal: 'center' }}
    >
      <Alert severity="success" variant="filled" onClose={() => setShowApprovedToast(false)}>
        Your account is approved — your free {tokenLabel} have been added.
      </Alert>
    </Snackbar>
  );
};

export default VerificationStatusBanner;
